export const MessageIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
    >
      <path
        d="M16.5 11.5a1.666 1.666 0 0 1-1.667 1.667h-10L1.5 16.5V3.167A1.667 1.667 0 0 1 3.167 1.5h11.666A1.666 1.666 0 0 1 16.5 3.167V11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
